<script>
  import Help from "../help.svelte";
  </script>

  <Help helpId={"Help15"} showSearchOption={false} back="/about"/>